import { Checkbox } from '@trackman/web-shared-components';

import { AppButton } from 'components/form';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

type MultiOptionFilterProps = {
    filter: { options: any[]; type: string; selectProps?: any; label?: string };
    onApply: (value?: any) => void;
};

export const MultiOptionFilter = ({ filter, onApply }: MultiOptionFilterProps) => {
    const [selectedValues, setSelectedValues] = useState<(string | number)[]>([]);
    const { t } = useTranslation();

    const onValueChange = (event) =>
    {
        const { value, checked } = event.target;
        setSelectedValues(prevState => 
            checked ? [...prevState, value] : prevState.filter(item => item !== value)
        );
    }

    return (
        <div className='data-table-filter-content gap-10px'>
            {filter.options.map((c, i) =>
            (
                <Checkbox
                    onChange={onValueChange}
                    data-test={`checkbox-${c.label?.replace(/\s/g, '')}`}
                    key={i} {...c}
                    onKeyDown={(e) => e.key === 'Enter' && onApply(selectedValues)}
                    checked={selectedValues?.includes(c.value)}
                    margin='3px'
                    label={c.label}
                />
            ))}

            <AppButton data-test='ApplyFilterSubmit' type='button' className='apply-button ' variant='primary' onClick={() => onApply(selectedValues)}>
                {t('apply')}
            </AppButton>
        </div>
    );
};

export default MultiOptionFilter;
